document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('[data-trigger]');
  if (!!triggers) {
    triggers.forEach((trigger) => {
      const hiddenInfo = trigger.querySelector('[data-hidden-info]');
      const shownInfo = trigger.querySelector('[data-shown-info]');
      trigger.addEventListener('click', function (event) {
        hiddenInfo.classList.remove('d-none');
        shownInfo.classList.add('d-none');
      });
    });
  }
});
